import { createFileRoute } from "@tanstack/react-router";
import { ActivityHistoryPage } from "@/components/activity-history/activity-history-page";

export const Route = createFileRoute("/_dashboard/activity")({
  component: ActivityHistoryPage,
});
